import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { posthog, isPostHogConfigured } from '../../lib/posthog'

/** SPA pageviews for React Router (PostHog init uses capture_pageview: false). */
export default function PostHogPageView() {
  const location = useLocation()
  const lastTracked = useRef('')

  useEffect(() => {
    if (!isPostHogConfigured) return

    const path = `${location.pathname}${location.search}${location.hash}`
    if (path === lastTracked.current) return
    lastTracked.current = path

    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: location.pathname,
      hash: location.hash || undefined,
    })
  }, [location])

  return null
}
